import React from "react";
import { Link } from "react-router-dom";

import './nav.css';

import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";

function Navigation() {
    return (
        <>
            <Navbar bg="black" variant="dark" expand="md" sticky="top">
                <Container style={{ marginInline: '0px' }}>
                    <Navbar.Brand as={Link} to="/">
                        <img src={require("../../photo/asco_white_trans.png")} style={{ width: 100, marginBottom: '5px', marginInline: '20px' }} />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/" style={{ marginInline: '17px' }}>Home</Nav.Link>
                        <Nav.Link as={Link} to="/services"  style={{ marginInline: '17px' }}> Services </Nav.Link>
                        <Nav.Link as={Link} to="/contact"  style={{ marginInline: '17px' }}> Contact Us </Nav.Link>
                        <Nav.Link as={Link} to="/location"  style={{ marginInline: '17px' }}> Our Location </Nav.Link>
                        <NavDropdown title="More" id="basic-nav-dropdown" style={{ marginInline: '17px' }}>
                         <NavDropdown.Item as={Link} to="/gallery"> Gallery </NavDropdown.Item>
                         <NavDropdown.Item as={Link} to="/about"> About Asco </NavDropdown.Item>
                         <NavDropdown.Item as={Link} to="/achievements"> Achievements </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default Navigation;